import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'p2p',
    loadChildren: () =>
      import('./components/p2p/p2p.module').then((m) => m.P2PModule),
    data: {
      title: 'p2p-plugin',
    },
  },
  {
    path: 'sale',
    loadChildren: () =>
      import('./components/sale/sale.module').then((m) => m.SaleModule),
    data: {
      title: 'sale-plugin',
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
